import React, {useContext, useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {GiHouseKeys} from "react-icons/gi";
import {MdApartment} from "react-icons/md";
import {MdBusinessCenter} from "react-icons/md";
import {GiKey} from "react-icons/gi";


import Logo from "../../assets/image/logo.svg";
import EstateList from "./EstateList";
import "../../assets/stylesheets/realestate.css";
import "../../assets/stylesheets/home-buttons.css";
import "../../assets/stylesheets/home.css";
import {FaBuilding, FaHandshake, FaMapMarkerAlt, FaStar, FaUsers} from "react-icons/fa";
import {TbHomeStar} from "react-icons/tb";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function Home() {
    const location = useLocation();
    const {t, i18n} = useTranslation(["home", "estate"]);
    const { contactInfo } = useContext(ContactInfoContext);

    // Create a stable filter Map to prevent re-renders
    const filter = useMemo(() => new Map(), []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <Helmet>
                <meta name="description" content={t("headDescription")}/>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}`}/>
                <title>{t("headTitle")}</title>
                <meta property="og:title" content={t("headTitle")}/>
                <meta property="og:site_name" content="sievn.am"/>
                <meta property="og:url" content={`https://sievn.am/${i18n.language}`}/>
                <meta property="og:description" content={t("headDescription")}/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:image" content={Logo}/>
                <link
                    href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500&family=Poppins:wght@700&family=Roboto:wght@400&display=swap"
                    rel="stylesheet"/>
            </Helmet>

            <section className="homepage">
                <div className="home__hero">
                    <img src={contactInfo.homeUrl} alt="Hero background" className="home__hero-image"/>
                    <div className="home__hero-overlay">
                        <div className="home__hero-content">
                            <h1 className="home__hero-text2">{t("company-name")}</h1>
                            <h2 className="home__hero-text3">{t("comfort-text")}</h2>
                        </div>
                    </div>
                </div>
                <div className="selection__buttons">
                    <Link to={`/${i18n.language}/${t("estate:sales-url")}`} className="selection__button">
                        <MdApartment className="selection__button-icon"/>
                        <span>{t("estate:sales-title")}</span>
                    </Link>
                    <Link to={`/${i18n.language}/${t("estate:rent-url")}`} className="selection__button">
                        <GiKey className="selection__button-icon"/>
                        <span>{t("estate:rent-title")}</span>
                    </Link>
                    <Link to={`/${i18n.language}/${t("estate:business-url")}`} className="selection__button">
                        <MdBusinessCenter className="selection__button-icon"/>
                        <span>{t("estate:business-title")}</span>
                    </Link>
                    <Link to={`/${i18n.language}/${t("estate:exclusive-url")}`} className="selection__button">
                        <TbHomeStar className="selection__button-icon"/>
                        <span>{t("estate:exclusive-title")}</span>
                    </Link>
                </div>

                <div className="home__features">
                    <div className="features__list">
                        <div className="feature__item">
                            <div className="feature__icon-circle">
                                <FaStar className="feature__icon"/>
                            </div>
                            <span className="feature__text">{t("features.experience")}</span>
                        </div>
                        <div className="feature__item">
                            <div className="feature__icon-circle">
                                <FaUsers className="feature__icon"/>
                            </div>
                            <span className="feature__text">{t("features.team")}</span>
                        </div>
                        <div className="feature__item">
                            <div className="feature__icon-circle">
                                <FaMapMarkerAlt className="feature__icon"/>
                            </div>
                            <span className="feature__text">{t("features.market")}</span>
                        </div>
                        <div className="feature__item">
                            <div className="feature__icon-circle">
                                <FaHandshake className="feature__icon"/>
                            </div>
                            <span className="feature__text">{t("features.trust")}</span>
                        </div>
                        <div className="feature__item">
                            <div className="feature__icon-circle">
                                <FaBuilding className="feature__icon"/>
                            </div>
                            <span className="feature__text">{t("features.offers")}</span>
                        </div>
                    </div>
                </div>


                <div className="home__top-estates">
                    <EstateList
                        type="search-top"
                        language={i18n.language}
                        query="top"
                        filter={filter}
                    />
                </div>
            </section>
        </>
    );
}

export default Home;